import { isGlobalAdmin } from "@/helpers/permissions/users";

export function isAdminOfCommunity(user, community) {
  if (!community) {
    return false;
  }

  return !!(user?.community_user_roles || []).find(
    (r) => r.community_id === community.id && r.role === "admin"
  );
}

export function getAdminCommunities(user) {
  return (user?.community_user_roles || [])
    .filter((r) => r.role === "admin")
    .map((r) => r.community);
}

export function isAdminOfSomeCommunity(user) {
  return getAdminCommunities(user).length > 0;
}

export function canSeeDeletedCommunity(user) {
  return isGlobalAdmin(user);
}

export function canManageCommunityRoles(user, community) {
  return isGlobalAdmin(user) || isAdminOfCommunity(user, community);
}
